
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_LANGUAGES from "@/apollo/autocomplete-queries/GetLanguages.gql";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootLanguageArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      languages: {
        query: GET_LANGUAGES,
        variables() {
          return this.languageAutocompleteFilter;
        },
        update(data) {
          return data.language;
        },
        skip() {
          return !this.languageSearchString;
        },
      },
    },
  })
  export default class LanguagesMultiselect extends Vue {
    @Prop({ type: Array, required: true }) value!: DropdownOption[];
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: Number, default: 1000 }) limit!: number;
    @Prop({ type: Number, default: undefined }) readonly max?: number;

    languages: DropdownOption[] = [];
    languageSearchString: string = "";

    get mappedLanguagesValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get languageAutocompleteFilter(): Query_RootLanguageArgs {
      const conditions: any[] = [
        {
          name: {
            _ilike: `%${this.languageSearchString}%`,
          },
        },
      ];

      if (this.mappedLanguagesValue.length) {
        conditions.push({
          name: {
            _nin: this.mappedLanguagesValue,
          },
        });
      }

      return {
        where: { _and: conditions },
        limit: this.limit,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
